import type { FC } from 'react';

import { ArrowExternalIcon } from '@truvhq/ui';
import { clsx } from 'clsx';

// Revealed on hover, where there is one. A touch screen has none, and the arrow is what says the row
// leaves the dashboard for another app, so there it is always shown.
export const InfoExternal: FC<{ className: string }> = ({ className }) => (
  <ArrowExternalIcon
    className={clsx(
      'pointer-events-none absolute right-6 top-1/2 mt-[1px] -translate-y-1/2 transform opacity-0 transition-opacity group-hover:opacity-100 [@media(hover:none)]:opacity-100',
      className,
    )}
  />
);
